module.exports = __webpack_public_path__ + "static/media/28DGC6.0feb0d44.jpg";